const pagesIndividualTasksEn = {
  approvalDialog: {
    approvalFlow: 'Approval Flow',
    approve: 'Approve',
    error: 'An error occurred',
    noData: 'No data available',
  },
  deviceInfoDisplay: {
    error: {
      fallback: 'An error occurred',
      title: 'Failed to retrieve data',
    },
    loading: 'Retrieving device information...',
    notFound: 'Device information not found',
  },
  deviceInventory: {
    completion: {
      backToTaskList: 'Back to Home',
      message: 'What to do next...',
      nextTask: 'Next Task',
      nextTaskLabel: 'Proceed to next task',
      packageLabel: 'Package',
      title: 'Task completed!',
    },
    errors: {
      noDeviceFound: 'No device found',
    },
    selfReportSection: {
      description: 'Report devices that are lent to you or that you manage.',
      taskTitle: 'Submit Self Report',
      title: 'Self Report',
    },
    title: 'Device Inventory',
  },
  form: {
    validationError: 'Input error: {{errorCount}} count',
  },
  navigateToHome: 'Home',
  pageTitle: 'Task',
  progressLabels: {
    step: 'Step Progress',
    task: 'Task Progress',
  },
  qrScannerField: {
    initialState: {
      buttonText: 'Take QR Code',
      description:
        'Point your camera at the QR code. Tap/click to launch camera',
      fallbackButton: 'If QR code is unreadable',
    },
    manualInputState: {
      backToScanButton: 'If you want to scan QR code',
    },
    scannedState: {
      rescanButton: 'Scan again',
      successMessage: 'QR code successfully scanned',
    },
    scanningState: {
      fallbackButton: 'If QR code is unreadable',
    },
  },
  selfReport: {
    deviceInventory: {
      deviceMismatchTitle: 'Device mismatch',
      deviceNotFound:
        'No device found matching the entered device management ID',
      deviceTagHint: 'Please enter the ID shown below the QR code.',
      deviceTagLabel: 'Device Management ID',
      deviceTagPlaceholder: 'DID1234',
      deviceTagRequired: 'Please enter the device management ID',
      manualInputMismatch:
        'The entered device management ID ({{inputTag}}) does not match the assigned device management ID ({{assignedTag}}). Please enter the correct ID.',
      obtainedDeviceTag: 'Obtained device management ID: {{deviceTag}}',
      scanMismatch:
        'The scanned device management ID ({{scannedTag}}) does not match the assigned device management ID ({{assignedTag}}). Please scan the correct QR code.',
    },
    form: {
      assetTag: 'Asset Management Tag',
      deviceId: 'Device ID',
      deviceInfo: 'Device Information',
      deviceStatus: {
        bad: 'Not Good',
        good: 'Good',
        label: 'Device Status',
      },
      remarks: {
        label: 'Remarks',
        placeholder: 'Requests, etc.',
      },
    },
    initialQuestion: {
      description: 'Please select the applicable option',
      next: 'Next',
      no: {
        description: 'I am not using it, or the situation has changed',
        hint: 'You will select a detailed reason on the next screen',
        label: 'No',
      },
      title: 'Is this device currently in your possession?',
      yes: {
        description: 'I am currently using or managing it',
        label: 'Yes',
      },
    },
    submit: 'Submit Report',
    title: 'Self Report',
    unavailableReport: 'If you cannot report the target device',
    unavailableReportForm: {
      backButton: 'Back',
      memo: {
        label: 'Remarks',
        optional: 'Optional',
        placeholder: 'Details of the situation, etc. (max 100 characters)',
      },
      memoTitle: 'Please describe the detailed reason',
      nextButton: 'Next',
      reasonLabel: 'Reason',
      reasonSelectionTitle: 'Please select a detailed reason',
      reasons: {
        lost: 'Lost',
        notKnown: 'Not lent to me, or not a managed device',
        other: 'Other',
        returned: 'Already returned or collected',
      },
      submitButton: 'Submit Report',
      title: 'If you cannot report the target device',
    },
  },
};

export default pagesIndividualTasksEn;
